/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form, Table, Badge, InputGroup, Modal } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaEye, FaSearch, FaTimes, FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Pagination from "../components/Pagination";
import { getTKT1ONMDesigns, deleteTKT1ONMDesign, createTKT1ONMDesign, getTKT1ONMDesignByID } from '../actions';

class TKT1ONMDesignList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: {
        currentPage: 1,
        itemsPerPage: 20,
        sortBy: 'created_at',
        sortOrder: -1,
        search: ''
      },
      loading: false,
      showDeleteModal: false,
      selectedDesign: null
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.setState({ loading: true });
    this.props.getTKT1ONMDesigns(apiQuery).finally(() => {
      this.setState({ loading: false });
    });
  };

  prepareApiQuery = (query) => {
    const { search, ...baseQuery } = query;
    return {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
  };

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    });
  };

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      currentPage: 1
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({ query: trimmedQuery }, () => {
      this.loadData();
    });
  };

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value, currentPage: 1 };
    this.setState({ query: newQuery }, () => {
      this.loadData();
    });
  };

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value), currentPage: 1 };
    this.setState({ query: newQuery }, () => {
      this.loadData();
    });
  };

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    this.setState({ query: trimmedQuery }, () => {
      this.loadData();
    });
  };

  handleViewClick = (design) => {
    this.props.history.push(`/admin/rnd/ornament/design-detail/${design.id}`);
  };

  handleEditClick = (design) => {
    this.props.history.push(`/admin/rnd/ornament/design-detail/${design.id}`);
  };

  handleDeleteClick = (design) => {
    this.setState({
      showDeleteModal: true,
      selectedDesign: design
    });
  };

  handleCloneClick = async (design) => {
    if (!design || !design.id) {
      toast.error('Không tìm thấy design để clone');
      return;
    }

    try {
      this.setState({ loading: true });
      
      // Fetch full design data first
      await this.props.getTKT1ONMDesignByID(design.id);
      const fullDesign = this.props.currentDesign || design;
      
      // Create new design based on original (remove id, update name)
      const clonedDesign = {
        name: `${fullDesign.name || 'Design'} (Copy)`,
        description: fullDesign.description || '',
        layers: fullDesign.layers ? JSON.parse(JSON.stringify(fullDesign.layers)) : []
      };
      
      // Create the cloned design
      const result = await this.props.createTKT1ONMDesign(clonedDesign);
      const newDesignId = result?.data?.data?.id || result?.data?.id;
      
      if (newDesignId) {
        toast.success('Clone design thành công!');
        // Redirect to the new design
        this.props.history.push(`/admin/rnd/ornament/design-detail/${newDesignId}`);
      } else {
        toast.error('Không thể lấy ID của design mới');
      }
    } catch (error) {
      console.error('Error cloning design:', error);
      toast.error('Lỗi khi clone design. Vui lòng thử lại.');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      selectedDesign: null
    });
  };

  handleConfirmDelete = async () => {
    const { selectedDesign } = this.state;
    
    if (!selectedDesign || !selectedDesign.id) {
      toast.error('Không tìm thấy design để xóa');
      return;
    }

    try {
      await this.props.deleteTKT1ONMDesign(selectedDesign.id);
      this.handleCloseDeleteModal();
      this.loadData();
      toast.success('Xóa design thành công!');
    } catch (error) {
      console.error('Error deleting design:', error);
      toast.error('Lỗi khi xóa design. Vui lòng thử lại.');
    }
  };

  updatePage = (itemOffset, newPage) => {
    if (newPage === this.state.query.currentPage) return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    this.setState({ query: trimmedQuery }, () => {
      this.loadData();
    });
  };

  renderSearchFilter = () => {
    return (
      <Row className="mb-3">
        <Col md="4">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo tên, mô tả..."
              aria-label="search"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="3">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="name">Tên</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="3" className="d-flex align-items-center justify-content-end gap-2">
          <Button variant="primary" onClick={this.handleSearch}>
            <FaSearch className="me-1" />
            Tìm kiếm
          </Button>
          <Button 
            variant="success" 
            onClick={() => this.props.history.push('/admin/rnd/ornament/design-detail/new')}
          >
            <FaPlus className="me-1" />
            Tạo Design Mới
          </Button>
        </Col>
      </Row>
    );
  };

  renderDesignsTable = () => {
    const { designs } = this.props;
    const safeDesigns = Array.isArray(designs) ? designs.filter(design => design != null) : [];
    
    if (!safeDesigns || safeDesigns.length === 0) {
      return (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>STT</th>
              <th>Tên Design</th>
              <th>Mô tả</th>
              <th>Số Layers</th>
              <th>Ngày tạo</th>
              <th>Ngày cập nhật</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={7} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên Design</th>
            <th>Mô tả</th>
            <th>Số Layers</th>
            <th>Ngày tạo</th>
            <th>Ngày cập nhật</th>
            <th>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeDesigns.map((design, index) => (
            <tr key={design.id}>
              <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
              <td>
                <strong>{design.name || '-'}</strong>
              </td>
              <td>
                <div style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={design.description}>
                  {design.description || '-'}
                </div>
              </td>
              <td>
                <Badge bg="info">{design.layers?.length || 0}</Badge>
              </td>
              <td>
                {design.created_at ? new Date(design.created_at).toLocaleString('vi-VN') : '-'}
              </td>
              <td>
                {design.updated_at ? new Date(design.updated_at).toLocaleString('vi-VN') : '-'}
              </td>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <Button 
                    variant="outline-primary" 
                    size="sm"
                    onClick={() => this.handleViewClick(design)}
                    title="Xem chi tiết"
                  >
                    <FaEye />
                  </Button>
                  <Button 
                    variant="outline-success" 
                    size="sm"
                    onClick={() => this.handleEditClick(design)}
                    title="Chỉnh sửa"
                  >
                    <FaEdit />
                  </Button>
                  <Button 
                    variant="outline-info" 
                    size="sm"
                    onClick={() => this.handleCloneClick(design)}
                    title="Clone (Sao chép)"
                    disabled={this.state.loading}
                  >
                    <FaCopy />
                  </Button>
                  <Button 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => this.handleDeleteClick(design)}
                    title="Xóa"
                  >
                    <FaTrash />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  render() {
    const { totalCount } = this.props;
    
    return (
      <Container fluid className="py-4">
        <Row className="mb-4">
          <Col>
            <h2 className="text-primary">ONM Design Management</h2>
          </Col>
        </Row>

        {this.renderSearchFilter()}

        <Row className="mb-3">
          <Col>
            <h5 className="d-inline-block">
              <b>Tìm thấy <span className='text-danger'>{totalCount || 0}</span> bản ghi:</b>
            </h5>
          </Col>
          <Col className="text-end text-nowrap" md="auto">
            <div className="d-inline-flex align-items-center">
              <span className="me-2">Số bản ghi/trang:</span>
              <Form.Select
                size="sm"
                value={this.state.query.itemsPerPage}
                onChange={this.handleChangeItemsPerPage}
                style={{ width: '100px', display: 'inline-block' }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Select>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <Card.Body className="p-0">
                {this.renderDesignsTable()}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Pagination 
          totalItems={totalCount || 0} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Delete Confirmation Modal */}
        <Modal show={this.state.showDeleteModal} onHide={this.handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Xác nhận xóa Design</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedDesign && (
              <div>
                <p>Bạn có chắc chắn muốn xóa design này không?</p>
                <div className="alert alert-warning" role="alert">
                  <strong>Tên:</strong> {this.state.selectedDesign.name || 'N/A'}<br/>
                  <strong>ID:</strong> {this.state.selectedDesign.id || 'N/A'}<br/>
                  <strong>Số layers:</strong> {this.state.selectedDesign.layers?.length || 0}
                </div>
                <p className="text-danger">
                  <strong>Cảnh báo:</strong> Hành động này không thể hoàn tác!
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
              Hủy
            </Button>
            <Button variant="danger" onClick={this.handleConfirmDelete}>
              <FaTrash className="me-1" />
              Xóa Design
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    designs: state.tkt1OnmDesignReducer.designs || [],
    totalCount: state.tkt1OnmDesignReducer.totalCount || 0,
    currentDesign: state.tkt1OnmDesignReducer.currentDesign
  };
};

export default withRouter(connect(mapStateToProps, { getTKT1ONMDesigns, deleteTKT1ONMDesign, createTKT1ONMDesign, getTKT1ONMDesignByID })(TKT1ONMDesignList));

